import * as React from 'react';
import { Link } from 'react-router';
import styled from 'styled-components';
import { rem } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexCol,
  FlexRow,
  FlexRowCenter,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';

export interface Props {
  address1: string;
  address2: string;
  phone: string;
  email: string;
  ico: string;
  icdph: string;
  title: string;
}

function ContactUpper({
  address1,
  address2,
  phone,
  email,
  ico,
  icdph,
  title,
}: Props) {
  // TODO remove and replace
  const osobnyOdber = `<div style="margin-top:15px">Osobný odber: </br> <b>Osobný odber</b> je možný <b>po vytvorení objednávky cez webovú stánku www.zlatapriadka.sk </br>

  Platba kartou</b> pri vytvorení objednávky alebo v <b>hotovosti</b> pri prevzatí objednávky. Platba kartou v sklade nie je možná. </br>
  
  Osobný odber je na adrese: Osloboditeľov 203, 977 03  Brezno- Mazorníkovo </br>
  
  UPOZORNENIE: <b>Nie sme predajňa.</b></div> `;

  return (
    <Wrapper>
      <LeftWrapper>
        <Name>{title}</Name>
        <ValueWrapper>
          <ValueName>{__('Sídlo')}</ValueName>
          <Phone>{address1}</Phone>
        </ValueWrapper>
        <ValueWrapper>
          <ValueName>{__('Prevádzka e-shopu')}</ValueName>
          <Phone>{address2}</Phone>
        </ValueWrapper>
        <ValueWrapper>
          <ValueName>{__('Tel. číslo')}</ValueName>
          <Phone>{phone}</Phone>
        </ValueWrapper>
        <ValueWrapper>
          <ValueName>{__('Email')}</ValueName>
          <Email>{email}</Email>
        </ValueWrapper>
        <ValueWrapper>
          <Phone dangerouslySetInnerHTML={{ __html: osobnyOdber }}></Phone>
        </ValueWrapper>
      </LeftWrapper>
      {ico && icdph && (
        <RightWrapper>
          <ValueWrapper>
            <ValueName>{__('IČO')}</ValueName>
            <Email>{ico}</Email>
          </ValueWrapper>
          <ValueWrapper>
            <ValueName>{__('IČ DPH')}</ValueName>
            <Email>{icdph}</Email>
          </ValueWrapper>
        </RightWrapper>
      )}
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  width: 100%;
  margin-bottom: ${rem(24)};

  ${({ theme }) => theme.mediab.l925`
    flex-flow: column;
    margin: 0;
  `}
`;

const RightWrapper = styled(FlexCol)`
  max-width: ${rem(328)};
  width: 100%;
`;

const LeftWrapper = styled(FlexCol)`
  margin-right: ${rem(32)};
  max-width: ${rem(600)};
  width: 100%;

  ${({ theme }) => theme.mediab.l925`
    margin: ${rem(32)} 0;
  `}

  ${({ theme }) => theme.mediab.s450`
    max-width: 100%;
  `}
`;

const Text = styled(TextP)`
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(22)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 400;
  font-size: ${rem(14)};
`;

const Name = styled(Text)`
  margin-bottom: ${rem(32)};
`;

const Phone = styled(Text)``;

const Email = styled(Text)`
  font-weight: 400;
`;

const ValueWrapper = styled(FlexRowCenterVertical)`
  margin-bottom: ${rem(4)};

  &:last-child {
    margin: 0;
  }
`;

const ValueName = styled(Text)`
  width: ${rem(200)};
  margin-right: ${rem(24)};
  font-weight: 400;
`;

const OrsrValueName = styled(ValueName)`
  margin-top: ${rem(24)};
  width: initial;
`;

export { ContactUpper };
